<template>
  <div class="setting-wheel">
    <el-popover
      v-if="isSmallScreen"
      id="button-setting"
      width="auto"
      placement="bottom"
      :trigger="isMobile ? 'click' : 'hover'"
    >
      <template #reference>
        <div class="setting-wheel"><img src="/static/img/icones/cogwheel.svg"></div>
      </template>
      <div class="menu-drop">
        <ul>
          <div v-for="(menuItem, index) in menu" :key="index">
            <li
              v-if="!menuItem.perms || (accountStore.permissions && accountStore.permissions[menuItem.perms])"
              ref="menuDrop"
              :class="menuItem.imgFolder"
              @click="switchTab(menuItem.title, index)"
            ><img :src="`/static/img/icones/parametre/${menuItem.imgFolder}.svg`">{{ $t(menuItem.title) }}
            </li>
          </div>
        </ul>
      </div>
    </el-popover>
    <div
      v-if="!isSmallScreen"
      class="setting-wheel"
      @click="goTo('profil')"
    ><img src="/static/img/icones/cogwheel.svg">
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useAccountStore } from '@/stores/account';
import { useAuthStore } from '@/stores/auth';
import { useNotifierStore } from '@/stores/notifier';

export default {
  data() {
    return {
      isSmallScreen: false,
      isMobile: /Mobi/i.test(window.navigator.userAgent),
      menu: [{
        title: 'settings.first_tab.title',
        imgFolder: 'profil',
      }, {
        title: 'settings.second_tab.title',
        imgFolder: 'entreprise',
        perms: 'customerEditInfos',
      }, {
        title: 'settings.fourth_tab.title',
        imgFolder: 'team',
      }, {
        title: 'settings.third_tab.title',
        imgFolder: 'paiement',
      }, {
        title: 'settings.fifth_tab.title',
        imgFolder: 'notification',
      }, {
        title: 'settings.menu.logout_link',
        imgFolder: 'logout',
      }],
    };
  },
  computed: {
    ...mapStores(useAccountStore, useAuthStore, useNotifierStore),

  },
  watch: {
    isSmallScreen() {
      this.$forceUpdate();
    },
  },
  mounted() {
    this.isSmallScreen = window.innerWidth < 1340;
    window.addEventListener('resize', () => {
      this.isSmallScreen = window.innerWidth < 1340;
    });
  },
  methods: {
    goTo(event) {
      if (event === 'profil') {
        this.$mixpanel.track('Profile Edit Displayed');
        this.$router.push({ path: '/me/settings' });
      }
    },
    logout() {
      this.$mixpanel.track('Disconnected');
      this.notifierStore.close();
      this.accountStore.clear();
      this.authStore.logout();
      this.$router.push('/login');
    },
    switchTab(val, index) {
      if (val !== 'settings.menu.logout_link') {
        if (this.$refs.menuDrop) {
          for (let i = 0; i < this.menu.length; i += 1) {
            if (this.$refs.menuDrop[i] && this.$refs.menuDrop[i].classList.contains('active')) {
              this.$refs.menuDrop[i].classList.remove('active');
            }
          }
          this.$refs.menuDrop[index].classList.add('active');
        }

        this.$router.replace({ name: 'me.settings', query: { tab: val } });
      } else {
        this.logout();
      }
    },
  },
};
</script>
